import { useState } from "react";
import { Link } from "react-router-dom";
import { BookMarked } from "lucide-react";
import { termsForLesson } from "@/lib/glossaryLessons";

const SHOW = 18;

// Bottom of a Learn Crypto lesson: the glossary terms whose "Learn more" points here, each a deep link back to its definition.
export const RelatedTerms = ({ slug }) => {
  const [all, setAll] = useState(false);
  const terms = termsForLesson(slug);
  if (!terms.length) return null;
  const shown = all ? terms : terms.slice(0, SHOW);
  return (
    <div className="apx-card p-5" data-testid="lesson-related-terms">
      <h2 className="font-display font-semibold text-base flex items-center gap-2"><BookMarked className="w-4 h-4 text-cyan-300" /> Terms from this lesson <span className="text-xs text-slate-500 font-normal">· {terms.length} in the glossary</span></h2>
      <p className="text-xs text-slate-400 mt-1">Tap a term to jump to its plain-language definition on the Terms explained page.</p>
      <div className="flex flex-wrap gap-1.5 mt-3">
        {shown.map((t) => (
          <Link key={t.k} to={`/glossary#term-${t.k}`} data-testid={`lesson-term-${t.k}`} className="rounded-full border border-slate-800 bg-slate-900/60 px-2.5 py-1 text-xs text-slate-200 hover:border-cyan-700 hover:text-cyan-200 transition-colors">{t.title}</Link>
        ))}
      </div>
      {terms.length > SHOW && (
        <button type="button" onClick={() => setAll((v) => !v)} className="mt-3 text-xs text-cyan-300 hover:underline" data-testid="lesson-terms-toggle">{all ? "Show fewer" : `Show all ${terms.length} terms`}</button>
      )}
    </div>
  );
};
